import { TThunkAction } from '../../types/redux/thunk';
import { getDistrictFlatStats } from '../../utils/district/getDistrictFlatStats';
import { setFieldsState } from '../fieldsState';

export function changeDistrict(district: string): TThunkAction {
  return async (dispatch, getState, context) => {
    const { logger } = context;
    const {
      fieldsState: { rooms, flatPrice, flatPriceChanged },
    } = getState();

    const flatStats = getDistrictFlatStats(district, rooms);
    if (!flatStats) {
      // TODO custom error
      logger.error(
        new Error(`[changeDistrict] Invalid rooms or district selected: rooms = "${rooms}", district = "${district}"`),
      );

      return;
    }

    const nextFlatPrice = !flatPriceChanged ? flatStats.price : flatPrice;
    dispatch(
      setFieldsState({
        district,
        flatPrice: nextFlatPrice,
        flatPriceInc: flatStats.percent,
      }),
    );
  };
}
